












































import { defineComponent } from "@vue/composition-api";
import { Cell, CellGroup, List, Icon, Button, Field, Popup, DatetimePicker, PullRefresh } from "vant";
import moment from "moment";

moment.locale("zh-cn");

export default defineComponent({
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [List.name]: List,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [PullRefresh.name]: PullRefresh
  },
  data: () => ({
    loading: false,
    finished: false,
    size: 10,
    paymentList: [],
    unpaidPayments: [],
    refreshing: false,
    expandedBillLists: {} // 用于跟踪账单列表的展开状态
  }),
  computed: {
    lastId() {
      return this.paymentList.length > 0 ? this.paymentList[this.paymentList.length - 1].id : -1;
    }
  },
  created() {
    this.fetchUnpaidPayment();
  },
  methods: {
    onRefresh() {
      this.finished = false;
      this.paymentList = [];
      this.unpaidPayments = []; // 重置未支付账单
      this.expandedBillLists = {}; // 重置展开状态
      this.fetchUnpaidPayment();
      this.fetchPaymentList();
      this.refreshing = false;
    },
    fetchUnpaidPayment() {
      this.$axios
        .post("/api/manage/settle/unpaidPayment")
        .then(res => {
          this.unpaidPayments = res.data.data.payments;
        })
        .catch(() => {});
    },
    fetchPaymentList() {
      this.$axios
        .post("/api/manage/settle/paymentList", { lastId: this.lastId, size: this.size })
        .then(res => {
          const data = res.data.data;
          this.paymentList = [...this.paymentList, ...data.paymentList];
          this.loading = false;
          if (data.paymentList.filter(p => p.id != 0).length < this.size) {
            this.finished = true;
          }
        })
        .catch(() => {});
    },
    dateFormat(date: string) {
      return moment(date).format("YYYY-MM-DD");
    },
    timeFormat(date: string) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    amountFormat(amount: number) {
      return amount / 100.0;
    },
    toggleBillList(payId: number) {
      this.$set(this.expandedBillLists, payId, !this.expandedBillLists[payId]);
    }
  }
});
